import type { FilterTag, ProposalListItem } from '@/lib/proposals/core/types';

export const RISKY_FILTER_TAGS = new Set<FilterTag>([
  'email',
  'calendar',
  'crm_delete',
  'crm_merge',
]);

export const DESTRUCTIVE_FILTER_TAGS = new Set<FilterTag>([
  'crm_delete',
  'crm_merge',
]);

export interface ApproveGroupRisk {
  hasRisk: boolean;
  hasDestructive: boolean;
  emailCount: number;
  calendarCount: number;
  destructiveCount: number;
}

export function detectApproveGroupRisk(
  proposals: ProposalListItem[]
): ApproveGroupRisk {
  let emailCount = 0;
  let calendarCount = 0;
  let destructiveCount = 0;

  for (const proposal of proposals) {
    const tags = proposal.filter_tags ?? [];
    if (tags.includes('email')) {
      emailCount++;
    }
    if (tags.includes('calendar')) {
      calendarCount++;
    }
    if (tags.includes('crm_delete') || tags.includes('crm_merge')) {
      destructiveCount++;
    }
  }

  const hasDestructive = destructiveCount > 0;
  const hasRisk = emailCount > 0 || calendarCount > 0 || hasDestructive;

  return {
    hasRisk,
    hasDestructive,
    emailCount,
    calendarCount,
    destructiveCount,
  };
}
